import React, { useEffect, useState } from 'react';
import { verificationAPI } from '../../services/api';
import Navbar from '../../components/Navbar';
import './History.css';

const History = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const response = await verificationAPI.getHistory(100, 0);
      setHistory(response.data);
    } catch (error) {
      console.error('Error fetching history:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (item) => {
    setSelectedItem(item);
  };

  const closeModal = () => {
    setSelectedItem(null);
  };

  if (loading) {
    return (
      <div className="history-page">
        <Navbar />
        <div className="loading">Loading history...</div>
      </div>
    );
  }

  return (
    <div className="history-page">
      <Navbar />
      
      <div className="history-container">
        <h1>Verification History</h1>
        
        {history.length === 0 ? (
          <div className="empty-state">
            <p>No verification history found</p>
          </div>
        ) : (
          <div className="history-table-container">
            <table className="history-table">
              <thead>
                <tr>
                  <th>Date & Time</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Amount</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {history.map(item => (
                  <tr key={item.id}>
                    <td>{new Date(item.date).toLocaleString()}</td>
                    <td>{item.type}</td>
                    <td>
                      <span className={`status-badge ${item.success ? 'success' : 'failed'}`}>
                        {item.success ? 'Success' : 'Failed'}
                      </span>
                    </td>
                    <td>₹{item.amount}</td>
                    <td>
                      <button
                        className="view-button"
                        onClick={() => handleViewDetails(item)}
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Details Modal */}
      {selectedItem && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Verification Details</h2>
              <button className="close-button" onClick={closeModal}>×</button>
            </div>
            
            <div className="modal-body">
              <div className="detail-row">
                <span className="detail-label">Type:</span>
                <span className="detail-value">{selectedItem.type}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Date:</span>
                <span className="detail-value">{new Date(selectedItem.date).toLocaleString()}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Status:</span>
                <span className={`status-badge ${selectedItem.success ? 'success' : 'failed'}`}>
                  {selectedItem.success ? 'Success' : 'Failed'}
                </span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Amount:</span>
                <span className="detail-value">₹{selectedItem.amount}</span>
              </div>
              
              <div className="detail-section">
                <h3>Request Data</h3>
                <pre>{JSON.stringify(selectedItem.requestData, null, 2)}</pre>
              </div>
              
              {selectedItem.responseData && (
                <div className="detail-section">
                  <h3>Response Data</h3>
                  <pre>{JSON.stringify(selectedItem.responseData, null, 2)}</pre>
                </div>
              )}
              
              {selectedItem.errorDetails && (
                <div className="detail-section error">
                  <h3>Error Details</h3>
                  <p>{selectedItem.errorDetails}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default History;
